module.exports = __webpack_public_path__ + "static/media/merchant-gif.ed716cc5.gif";